<template>
	<section id="latest" class="sg-section" style="background: #fff;">
		<v-container>
			<h2 class="sg-section-title">{{ content.title }}</h2>
			<div class="sg-gold-line"></div>
			<p class="sg-section-subtitle">{{ content.subtitle }}</p>

			<v-carousel class="sg-latest-carousel rounded-xl" :height="carouselHeight" hide-delimiter-background delimiter-icon="mdi-minus" show-arrows cycle>
				<v-carousel-item v-for="(group, i) in groupedItems" :key="i">
					<v-row class="fill-height pa-4" align="center" justify="center">
						<v-col v-for="item in group" :key="item.id" cols="12" sm="6" md="4">
							<v-card class="sg-product-card" elevation="0" @click="$emit('order', item)">
								<div class="sg-product-img" style="height: 160px;">
									<v-icon>{{ item.icon || 'mdi-diamond-stone' }}</v-icon>
								</div>
								<v-card-text class="text-center pa-4">
									<v-chip x-small color="#C9A227" text-color="#1a1a1a" class="mb-2">جدید</v-chip>
									<h3 class="font-weight-bold mb-1">{{ item.name }}</h3>
									<div class="grey--text mb-2" style="font-size: 0.85rem;">
										{{ item.weight }} گرم — اجرت {{ item.wage }}٪
									</div>
									<div class="font-weight-bold" style="color: #C9A227;">
										{{ formatPrice(item.price) }} تومان
									</div>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-carousel-item>
			</v-carousel>

			<div v-if="editable" class="text-center mt-4">
				<v-btn small outlined color="primary" @click="edit()">ویرایش</v-btn>
			</div>
		</v-container>

		<v-dialog v-model="settingsDialog" persistent max-width="600px">
			<v-card>
				<v-card-title>ویرایش جدیدترین زیورآلات</v-card-title>
				<v-card-text>
					<v-text-field v-model="settings.title" label="عنوان" outlined dense />
					<v-text-field v-model="settings.subtitle" label="زیرعنوان" outlined dense />
					<v-card v-for="(item, idx) in settings.items" :key="idx" outlined class="mb-3 pa-3">
						<v-row dense>
							<v-col cols="12"><v-text-field v-model="item.name" label="نام" dense outlined /></v-col>
							<v-col cols="4"><v-text-field v-model.number="item.weight" label="وزن" type="number" dense outlined /></v-col>
							<v-col cols="4"><v-text-field v-model.number="item.wage" label="اجرت %" type="number" dense outlined /></v-col>
							<v-col cols="4"><v-text-field v-model.number="item.price" label="قیمت" type="number" dense outlined /></v-col>
							<v-col cols="12" class="text-left">
								<v-btn x-small text color="red" @click="settings.items.splice(idx, 1)">حذف</v-btn>
							</v-col>
						</v-row>
					</v-card>
					<v-btn small color="primary" @click="addItem">افزودن آیتم</v-btn>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="settingsDialog = false">بستن</v-btn>
					<v-btn color="primary" :loading="submitEditLoading" @click="submitEdit">ذخیره</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
	import { cloneDeep } from 'lodash'
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'LatestSection',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean },
			goldPrice: { type: Number },
		},
		data: () => ({
			localData: null,
			settings: {},
			settingsDialog: false,
			submitEditLoading: false,
		}),
		computed: {
			...get('siteConfig', ['customerCode']),
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			},
			carouselHeight() {
				return this.$vuetify.breakpoint.smAndDown ? 380 : 320
			},
			groupedItems() {
				let items = this.content.items || []
				items = items.map(x => {
					let prd = { ...x }
					prd.price = prd.weight * this.goldPrice
					return prd
				})
				const groups = []
				for (let i = 0; i < items.length; i += 3) {
					groups.push(items.slice(i, i + 3))
				}
				return groups.length ? groups : [[]]
			},
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content),
				}
			} else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent(),
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					title: 'جدیدترین زیورآلات',
					subtitle: 'تازه‌ترین طراحی‌های طلا و جواهر',
					items: [
						{ id: 1, name: 'گردنبند طلا طرح ماه', weight: 3.5, wage: 17, price: 32800000, icon: 'mdi-necklace' },
						{ id: 2, name: 'انگشتر طلا کلاسیک', weight: 2.0, wage: 18, price: 18900000, icon: 'mdi-ring' },
						{ id: 3, name: 'دستبند طلا کار شده', weight: 5.2, wage: 20, price: 48500000, icon: 'mdi-watch-variant' },
						{ id: 4, name: 'گوشواره طلا الماس', weight: 1.8, wage: 22, price: 17200000, icon: 'mdi-ear-hearing' },
						{ id: 5, name: 'ست طلا عروس', weight: 15.0, wage: 19, price: 142000000, icon: 'mdi-diamond-stone' },
						{ id: 6, name: 'پابند طلا ظریف', weight: 2.5, wage: 15, price: 23500000, icon: 'mdi-foot-print' },
					],
				}
			},
			formatPrice(val) {
				return Number(val).toLocaleString('fa-IR')
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			addItem() {
				this.settings.items.push({ id: Date.now(), name: '', weight: 0, wage: 0, price: 0, icon: 'mdi-diamond-stone' })
			},
			submitEdit() {
				this.submitEditLoading = true
				const data = cloneDeep(this.localData)
				data.content = JSON.stringify(this.settings)
				api.post('admin/SiteContent/CreateUpdate', data)
					.then(() => {
						this.localData.content = cloneDeep(this.settings)
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.settingsDialog = false
					})
					.catch(err => toast.error(err.message))
					.finally(() => { this.submitEditLoading = false })
			},
		},
	}
</script>
